(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-check-out"]) return;
  try {
    
  const checkoutBtn = document.getElementById('checkout-button');

  checkoutBtn.querySelector('button').addEventListener('click', async (e) => {
    e.preventDefault();
    
    // Hämta den senaste datan från cart attributes
    const cartRes = await fetch(window.Shopify.routes.root + 'cart.js').then(res => res.json());
    const attrs = cartRes.attributes;
    
    // Datumet sparas ofta i sessionStorage på produktsidan, annars ta från attribut
    const finalDate = sessionStorage.getItem('deliveryDate') || attrs.leveransdatum;
    const zip = document.getElementById('zip-input')?.value || attrs.postnummer || "";
    const city = attrs.ort || "";

    if (!hasSubscription && zip) {
      // ✅ Spara ner allt som Line Item Properties
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          line: 1, 
          properties: {
            "Postnummer": zip,
            "Ort": city,
            "Leveransval": "Valt datum",
            "Leveransdatum": finalDate || ""
          } 
        }),
      });
    }

    window.location.href = '/checkout';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-gift-info"]) return;
  try {
    
  const giftMessageInputElement = document.getElementById('gift-message-input');

  /** Script to Handle Content Changes When All Subscriptions Are Removed **/

  const giftMessageBodyTextElement = document.getElementById('gift-message-body-text');
  const giftMessageSubscriptionMessageElement = document.getElementById('gift-message-subscription-message');

  // Adds event listener to when the cart is updated.
  window.addEventListener('cart_changed', ({ detail }) => {
    if (!detail.hasSubscription) {
      if (giftMessageBodyTextElement) {
        giftMessageBodyTextElement.classList.remove('hidden');
      }

      if (giftMessageSubscriptionMessageElement) {
        giftMessageSubscriptionMessageElement.remove();
      }

      giftMessageInputElement.classList.replace('hidden', 'flex');
    }
  });

  /** Script to Handle Gift Message Updating **/

  var giftMessageUpdateTimeout;

  // Uses Shopify's cart API to store the gift message.
  const storeGiftMessage = (giftMessage) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: { giftMessage: giftMessage.substring(0, 200) } }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Updates the cart when the gift message input changes.
  giftMessageInputElement.addEventListener('input', ({ target }) => {
    clearTimeout(giftMessageUpdateTimeout);

    giftMessageUpdateTimeout = setTimeout(() => {
      storeGiftMessage(target.value);
    }, 500);
  });

  /** Script to Handle Phone Number Updating **/

  const phoneNumberInputElement = document.getElementById('phone-number-input');

  var phoneNumberUpdateTimeout;

  // Uses Shopify's cart API to store the phone number.
  const storePhoneNumber = (phoneNumber) => {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: { phoneNumber } }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Updates the cart when the gift message input changes.
  phoneNumberInputElement.addEventListener('input', ({ target }) => {
    clearTimeout(phoneNumberUpdateTimeout);

    phoneNumberUpdateTimeout = setTimeout(() => {
      storePhoneNumber(target.value);
    }, 500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-items"]) return;
  try {
    
  const cartListItems = document.querySelectorAll('#cart-list > li:not(#empty-cart)');

  // Uses Shopify's cart API to update a cart item's quantity.
  const updateCartItemQuantity = (id, quantity) => {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, quantity }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Adds event listeners to quantity update elements for all cart list items.
  cartListItems.forEach((lineItemElement) => {
    const id = lineItemElement.id;
    const removeButton = lineItemElement.querySelector('.remove-from-cart');
    const incrementButton = lineItemElement.querySelector('.increment-quantity');
    const decrementButton = lineItemElement.querySelector('.decrement-quantity');

    const removeFromCart = async () => {
      await updateCartItemQuantity(id, 0);
    };

    const updateQuantity = async (quantityChange) => {
      const quantity = parseInt(lineItemElement.dataset.quantity);
      const newQuantity = quantity + quantityChange;

      if (newQuantity > 0) {
        await updateCartItemQuantity(id, newQuantity);
        lineItemElement.dataset.quantity = newQuantity;
      }
    };

    removeButton.addEventListener('click', () => removeFromCart());
    incrementButton.addEventListener('click', () => updateQuantity(1));
    decrementButton.addEventListener('click', () => updateQuantity(-1));
  });

  // Listens for cart changes and updates the cart list accordingly.
  window.addEventListener('cart_changed', ({ detail }) => {
    const updatedCartItems = [...detail.added, ...detail.removed];
    const emptyCartElement = document.getElementById('empty-cart');
    const totalCartPriceElement = document.querySelector('.total-cart-price');

    if (updatedCartItems.length === 0) return;

    updatedCartItems.forEach(({ id }) => {
      const lineItemElement = document.getElementById(id);
      const quantityElement = lineItemElement.querySelector('.quantity');
      const totalLinePriceElement = lineItemElement.querySelector('.total-line-price');

      const lineItem = detail.cart.items.find((item) => item.id === id);
      const quantity = lineItem?.quantity ?? 0;
      const totalLinePrice = lineItem?.final_line_price ?? 0;

      if (quantity > 0) {
        quantityElement.textContent = `${quantity} st`;
        totalLinePriceElement.textContent = Shopify.formatMoney(totalLinePrice);
      } else {
        lineItemElement.remove();
      }
    });

    if (detail.cart.item_count === 0) {
      emptyCartElement.classList.remove('hidden');
    }

    totalCartPriceElement.textContent = Shopify.formatMoney(detail.cart.total_price);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-links"]) return;
  try {
    
  const collectionLinks = document.getElementById('collection-links');
  const scrollIndicator = document.getElementById('scroll-indicator');

  // Set the width of the scroll indicator based on the number of collection links.
  const setScrollIndicatorWidth = () => {
    const winWidth = window.innerWidth;

    if (scrollIndicator) {
      if (winWidth > 640) {
        scrollIndicator.style.width = `calc(400% / ${collectionLinks.children.length})`;
      } else {
        scrollIndicator.style.width = `calc(200% / ${collectionLinks.children.length})`;
      }
    }
  };

  window.addEventListener('load', setScrollIndicatorWidth);
  window.addEventListener('resize', setScrollIndicatorWidth);

  // When the collection links are scrolled, update the scroll indicator's position.
  if (collectionLinks) {
    collectionLinks.addEventListener('scroll', () => {
      const scrollPercentage = collectionLinks.scrollLeft / (collectionLinks.scrollWidth - collectionLinks.clientWidth);
      const scrollIndicatorWidth = scrollIndicator.clientWidth;
      const scrollIndicatorRailWidth = scrollIndicator.parentElement.clientWidth;

      scrollIndicator.style.left = `${(scrollIndicatorRailWidth - scrollIndicatorWidth) * scrollPercentage}px`;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"]) return;
  try {
    
  const quickAddToCartButtonElements = document.querySelectorAll('.quick-add-to-cart-button');

  // Uses Shopify's cart API to add a product to the cart.
  const addProductToCart = (id, quantity) => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity }] }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  quickAddToCartButtonElements.forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();

      const productId = button.getAttribute('data-product-id');

      await addProductToCart(productId, 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"]) return;
  try {
    
  const quickAddToCartButtonElements = document.querySelectorAll('.quick-add-to-cart-button');

  // Uses Shopify's cart API to add a product to the cart.
  const addProductToCart = (id, quantity) => {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity }] }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((e) => {
        console.error(e);
      });
  };

  quickAddToCartButtonElements.forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();

      const productId = button.getAttribute('data-product-id');

      await addProductToCart(productId, 1);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /** Script to Handle Cart Item Count Updating **/

  const cartItemCountElement = document.getElementById('cart-item-count');

  window.addEventListener('cart_changed', ({ detail }) => {
    cartItemCountElement.textContent = detail.cart.item_count || '';
  });

  /** Script to Handle Dropdowns Showing **/

  const header = document.querySelector('header');
  const mainMenuLinks = document.querySelectorAll('#main-menu li');
  const dropdowns = document.querySelectorAll('#dropdown-wrapper > div');

  mainMenuLinks.forEach((link, i) => {
    if (link.classList.contains('has-child-links')) {
      const dropdown = dropdowns[i];

      link.addEventListener('mouseenter', () => {
        dropdown.classList.add('opacity-100', 'pointer-events-auto');
        link.classList.add('p-1.5xgutter', '-m-1.5xgutter');
      });

      header.addEventListener('mouseleave', () => {
        dropdown.classList.remove('opacity-100', 'pointer-events-auto');
        link.classList.remove('p-1.5xgutter', '-m-1.5xgutter');
      });

      header.addEventListener('mousemove', () => {
        if (!link.matches(':hover') && !dropdown.matches(':hover')) {
          dropdown.classList.remove('opacity-100', 'pointer-events-auto');
          link.classList.remove('p-1.5xgutter', '-m-1.5xgutter');
        }
      });
    }
  });

  /** Script to Handle Side Menu Toggling  **/

  const sideMenuToggleButton = document.getElementById('side-menu-toggle-button');

  var activeSideMenu = false;

  const toggleSideMenu = () => {
    const body = document.querySelector('body');
    const sideMenu = document.getElementById('side-menu');
    const sideMenuOpenIcon = sideMenuToggleButton.firstElementChild;
    const sideMenuCloseIcon = sideMenuToggleButton.lastElementChild;

    activeSideMenu = !activeSideMenu;

    if (activeSideMenu) {
      body.classList.add('overflow-y-hidden');
      sideMenu.classList.add('translate-x-full');

      sideMenuOpenIcon.classList.replace('flex', 'hidden');
      sideMenuCloseIcon.classList.replace('hidden', 'flex');
    } else {
      body.classList.remove('overflow-y-hidden');
      sideMenu.classList.remove('translate-x-full');

      sideMenuOpenIcon.classList.replace('hidden', 'flex');
      sideMenuCloseIcon.classList.replace('flex', 'hidden');
    }
  };

  sideMenuToggleButton.addEventListener('click', toggleSideMenu);

  /** Script to Handle Side Menu Submenu Toggling **/

  const sideMenuLinks = document.querySelectorAll('#side-menu li');
  const submenus = document.querySelectorAll('#side-menu-submenu-wrapper > div');
  const sideMenuMenuWrapper = document.getElementById('side-menu-menu-wrapper');
  const submenuBackButtons = document.querySelectorAll('#side-menu-submenu-wrapper button');

  sideMenuLinks.forEach((link, i) => {
    if (link.classList.contains('has-child-links')) {
      const submenu = submenus[i];

      link.addEventListener('click', () => {
        sideMenuMenuWrapper.classList.replace('flex', 'hidden');
        submenu.classList.replace('hidden', 'flex');
      });
    }
  });

  submenuBackButtons.forEach((button, i) => {
    const submenu = submenus[i];

    button.addEventListener('click', () => {
      sideMenuMenuWrapper.classList.replace('hidden', 'flex');
      submenu.classList.replace('flex', 'hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-form"]) return;
  try {
    
  window.onload = () => {
    (($) => {
      window.fnames = new Array();
      window.ftypes = new Array();
      fnames[0] = 'EMAIL';
      ftypes[0] = 'email';
      fnames[1] = 'FNAME';
      ftypes[1] = 'text';
      fnames[2] = 'LNAME';
      ftypes[2] = 'text';
      fnames[3] = 'ADDRESS';
      ftypes[3] = 'address';
      fnames[4] = 'PHONE';
      ftypes[4] = 'phone';
      fnames[5] = 'BIRTHDAY';
      ftypes[5] = 'birthday';
    })(jQuery);

    var $mcj = jQuery.noConflict(true);

    $mcj.extend($mcj.validator.messages, {
      required: 'Detta fält är obligatoriskt.',
      email: 'Vänligen ange en giltig e-postadress.',
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"]) return;
  try {
    
  /** Script To Add Products to Cart  **/

  const initQuickAddToCartButtons = () => {
    const quickAddToCartButtonElements = document.querySelectorAll('.quick-add-to-cart-button');

    // Uses Shopify's cart API to add a product to the cart.
    const addProductToCart = (id, quantity) => {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }] }),
      })
        .then((response) => {
          return response.json();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    quickAddToCartButtonElements.forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();

        const productId = button.getAttribute('data-product-id');

        await addProductToCart(productId, 1);
      });
    });
  };

  /** Script To Fetch The Recommendations **/

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('#product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          initQuickAddToCartButtons();
        }
      })
      .catch((e) => {});
  };

  const productRecommendationsSection = document.querySelector('#product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 400px 0px' });

  if (productRecommendationsSection) {
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
